import buildUrl from 'modules/core/lib/buildUrl'

import {
  StrategyItem,
  StrategySelectorEmployee,
  StrategySelectorTeam,
  StrategySelectorTreeRoles,
} from './interfaces'
import { getStrategyOptions } from './strategyUtils'

export const getStrategyDisplayInfo = (data: {
  strategy: StrategyItem
  employees: Array<StrategySelectorEmployee>
  teams: Array<StrategySelectorTeam>
  roles: Array<StrategySelectorTreeRoles>
}): { label: string; avatarText: string; avatarSrc?: string } => {
  const { strategy, employees, teams, roles } = data

  const strategyLabel = getStrategyOptions(strategy.type).label || strategy.type

  if (strategy.type === 'manual_selection' && strategy.employeeId) {
    const employee = employees.find((emp) => emp.id === strategy.employeeId)
    const fullName = employee?.fullName || ''
    const initials = fullName
      .split(' ')
      .map((n) => n.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2)

    const avatarUrl = employee?.avatar
    return {
      label: fullName,
      avatarSrc: avatarUrl ? buildUrl(avatarUrl) : undefined,
      avatarText: initials || 'U',
    }
  }

  if (strategy.teamId) {
    const team = teams.find((t) => t.id === strategy.teamId)
    const teamName = team?.name || ''

    let label = ''
    if (strategy.type === 'team_leads') {
      label = `Team leads of ${teamName}`
    } else if (strategy.type === 'anyone_in_team') {
      label = `Anyone in ${teamName}`
    } else {
      label = `${strategyLabel} - ${teamName}`
    }

    return {
      label,
      avatarText: teamName.charAt(0).toUpperCase() || 'T',
      avatarSrc: undefined,
    }
  }

  if (strategy.roleId) {
    let roleName = ''

    if (strategy.roleId.startsWith('jobcatalog_treerole-')) {
      roleName = roles.find((r) => r.uuid === strategy.roleId)?.name || ''
    } else {
      const role = roles.find((r) => r.id === Number(strategy.roleId))
      roleName = role?.name || ''
    }

    return {
      label: `${strategyLabel} - ${roleName}`,
      avatarText: roleName.charAt(0).toUpperCase() || 'R',
      avatarSrc: undefined,
    }
  }

  return {
    label: strategyLabel,
    avatarText: strategyLabel.charAt(0).toUpperCase() || 'S',
    avatarSrc: undefined,
  }
}
